import MDCRadio, { NativeRadioControl } from '@material/react-radio';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Radio.scss';
import { CSS_CLASSES } from './_constants';

const radio = ({
	checked,
	disabled,
	id,
	name,
	onChange,
	wrapperClasses,
	value,
	...props
}) => {
	return (
		<MDCRadio
			wrapperClasses={classNames([CSS_CLASSES.CONTAINER, wrapperClasses])}
			{...props}
		>
			<NativeRadioControl
				checked={checked}
				disabled={disabled}
				id={id}
				name={name}
				onChange={onChange ? e => onChange(e) : null}
				value={value}
			/>
		</MDCRadio>
	);
};

// documentation: https://github.com/material-components/material-components-web-react/tree/master/packages/radio#radio-props
radio.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string,
	wrapperClasses: PropTypes.string,
};

// documentation: https://github.com/material-components/material-components-web-react/tree/master/packages/radio#nativeradiocontrol-props
NativeRadioControl.propTypes = {
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	id: PropTypes.string,
	name: PropTypes.string,
	onChange: PropTypes.func,
	value: PropTypes.string,
};

export default radio;
